import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useRef } from 'react';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { TablePagination } from '@material-ui/core';
import DropDown from '../ui/react-ui/dropdown';
import DataTable from '../ui/table'; // api

import { getLogsTerminalsUnfinished } from '../../api/statsAPI';
import { getAreaTerminals } from '../../api/areaAPI'; // redux

import { setLogsTerminals, setLogsTerminalsSort } from '../../redux/line-dashboard';
var t = i18n.getFixedT(null, 'line-dashboard');
var gt = i18n.getFixedT(null, 'app');

var LogsTerminalsTable = function LogsTerminalsTable() {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$lineDash = _useSelector.lineDashboard,
      logsTerminals = _useSelector$lineDash.logsTerminals,
      logsTerminalsSort = _useSelector$lineDash.logsTerminalsSort,
      zonesList = _useSelector.app.zonesList;

  var dispatch = useDispatch();

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      curZoneId = _useState2[0],
      setCurZoneId = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      curTerminalId = _useState4[0],
      setCurTermianlId = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      totalCount = _useState6[0],
      setTotalCount = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      currentPage = _useState8[0],
      setCurrentPage = _useState8[1];

  var _useState9 = useState(10),
      _useState10 = _slicedToArray(_useState9, 2),
      rowsPerPage = _useState10[0],
      setRowsPerPage = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      terminalsList = _useState12[0],
      setTerminalsList = _useState12[1];

  var isMounted = useRef(false);

  var fetchData = function fetchData() {
    var offset = (Number(currentPage + 1) - 1) * rowsPerPage;
    getLogsTerminalsUnfinished(contextRoot, false, curZoneId, curTerminalId, logsTerminalsSort, offset, rowsPerPage).then(function (result) {
      if (result.totalElements !== totalCount) setTotalCount(result.totalElements);

      var newData = _.cloneDeep(result);

      _.map(newData.content, function (el, index) {
        el.sequence = offset + index + 1;
      });

      dispatch(setLogsTerminals(newData));
    });
  };

  useEffect(function () {
    if (isMounted.current) fetchData();
  }, [curTerminalId, JSON.stringify(logsTerminalsSort), currentPage, rowsPerPage]);
  useEffect(function () {
    if (isMounted.current && logsTerminals.totalElements !== totalCount) setTotalCount(logsTerminals.totalElements);
  }, [JSON.stringify(logsTerminals)]);
  useEffect(function () {
    if (isMounted.current) {
      if (curZoneId === '') {
        setTerminalsList([]);
      } else {
        getAreaTerminals(contextRoot, true, curZoneId, null, 0, null, null, true).then(function (result) {
          var tList = _.map(result.content, function (el) {
            return {
              value: el.id,
              text: el.name
            };
          });

          setTerminalsList(tList);
        });
      }

      if (_.isEmpty(curTerminalId)) {
        fetchData();
      } else {
        setCurTermianlId('');
      }
    }
  }, [curZoneId]);
  useEffect(function () {
    if (!isMounted.current) isMounted.current = true;
  }, []);

  var handleSort = function handleSort(sort) {
    dispatch(setLogsTerminalsSort(sort));
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var handleSplitTime = function handleSplitTime(time) {
    if (_.isEmpty(time)) return '';
    var timeAry = time.split(' ');
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, timeAry[0]), /*#__PURE__*/React.createElement("div", null, timeAry[1]));
  };

  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'terminalName', {
    label: t('lbl-terminals')
  });

  _.set(fields, 'trailerPlateNo', {
    label: t('lbl-trailerPlateNo'),
    sortable: true
  });

  _.set(fields, 'deliverType', {
    label: t('lbl-container-deliver-types'),
    sortable: true,
    formatter: function formatter(val, row) {
      return val ? t('lbl-' + val.toUpperCase()) : '';
    }
  });

  _.set(fields, 'transportType', {
    label: t('lbl-transport-type'),
    sortable: true
  });

  _.set(fields, 'entryTime', {
    label: t('lbl-work-entry-time'),
    sortable: true,
    formatter: function formatter(val) {
      return handleSplitTime(val);
    }
  });

  return /*#__PURE__*/React.createElement("div", {
    className: "logs-terminals-table"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, t('lbl-field-container-list')), /*#__PURE__*/React.createElement("div", {
    className: "selector"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label"
  }, t('lbl-zone-center'), ": "), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-all-zones-center'),
    list: zonesList,
    value: curZoneId,
    onChange: function onChange(value) {
      setCurZoneId(value);
      setCurrentPage(0);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "selector"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label"
  }, t('lbl-terminals'), ": "), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-all-terminals'),
    list: terminalsList,
    value: curTerminalId,
    onChange: function onChange(value) {
      setCurTermianlId(value);
      setCurrentPage(0);
    },
    width: '186px'
  }))), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt dataTable-wrap"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: logsTerminals.content ? logsTerminals.content : '',
    sort: logsTerminalsSort,
    onSort: handleSort
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: gt('global.lbl-per-page-row-count'),
    count: totalCount,
    page: currentPage,
    onChangePage: function onChangePage(e, newPage) {
      return setCurrentPage(newPage);
    },
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }));
};

export default LogsTerminalsTable;